var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"work-schedule-timeline__current-day",style:(`left:${_vm.offset}`)})
}
var staticRenderFns = []

export { render, staticRenderFns }